// Keeps the cart's offers block showing products the customer has not already added.
//
// The block renders six cards and shows the first three; the rest are reserves. When the cart
// changes, any card whose product is now in the cart is hidden and the next reserve takes its
// place. The cart's own markup carries everything needed, so this costs no request: the line
// items expose `data-product-id`, and each card's holder already carries the product id that
// the quick-add code uses.
(function () {
  const OFFERS = '[data-offer-products]';
  const CARD = '[data-quick-add-holder]';
  const LINE_ITEM = '[data-product-id]';

  function productIdsInCart() {
    const ids = new Set();
    document.querySelectorAll(LINE_ITEM).forEach((item) => {
      const id = item.getAttribute('data-product-id');
      if (id) ids.add(id);
    });
    return ids;
  }

  // Two copies of the block can be on the page: the filled cart's and the empty cart's
  function sync() {
    const inCart = productIdsInCart();
    document.querySelectorAll(OFFERS).forEach((holder) => syncHolder(holder, inCart));
  }

  function syncHolder(holder, inCart) {
    const visibleLimit = parseInt(holder.getAttribute('data-offers-visible'), 10) || 3;
    let shown = 0;

    holder.querySelectorAll(CARD).forEach((card) => {
      // the holder sits inside the element the grid lays out, which is what we show and hide
      const slot = card.parentElement;
      if (!slot) return;

      const id = card.getAttribute('data-quick-add-holder');
      const keep = !inCart.has(id) && shown < visibleLimit;

      slot.hidden = !keep;
      if (keep) shown += 1;
    });

    // With every candidate in the cart there is nothing left to suggest, and a heading promising
    // discounts over an empty grid is worse than no block. It comes back on the next page load,
    // where the server picks fresh candidates.
    const widget = holder.closest('[data-upsell-widget]');
    if (widget) widget.hidden = shown === 0;
  }

  document.addEventListener('theme:cart:change', sync);
  document.addEventListener('DOMContentLoaded', sync);

  if (document.readyState !== 'loading') sync();
})();
